import {Component, Inject, OnInit} from '@angular/core';
import { FaqHttpService } from '../../../services/http/faqHttp.service';
import { FaqNodeDetailDto } from '../../../domain/faq/faqNodeDetailDto';
import { FaqNodeDto } from '../../../domain/faq/faqNodeDto';
import { FaqNodeType } from '../../../domain/faq/faqNodeType';
import { FaqPageDetailDto } from '../../../domain/faq/faqNodeDetailDto';
import { HOST_THIRD_PARTY_ID } from '../../../tokens/thirdParty.token';
import { isFaqFolderDetail } from '../../../domain/faq/faqNodeDetailDto';
import { isFaqPageDetail } from '../../../domain/faq/faqNodeDetailDto';
import { SupportContact } from '../../../domain/operator/frontEndConfig';
import { SupportContactBusinessService } from '../../../services/business/supportContactBusiness.service';
import {NavController, ViewDidEnter, ViewWillEnter} from '@ionic/angular';
import {ActivatedRoute} from '@angular/router';
import {finalize} from 'rxjs/operators';
import { GhostComponent } from '../../../utils/ghostComponent';

@Component({
    selector: 'faq-node.view',
    templateUrl: './faqNode.view.html',
    styleUrls: ['./faqNode.view.scss'],
})
export class FaqNodeView extends GhostComponent implements OnInit, ViewWillEnter, ViewDidEnter {
    faqNodeDetailDto: FaqNodeDetailDto;

    supportContacts: SupportContact[];


    isFaqFolderDetail = isFaqFolderDetail;
    isFaqPageDetail = isFaqPageDetail;

    constructor(private readonly faqHttpService: FaqHttpService,
        private readonly supportContactService: SupportContactBusinessService,
        @Inject(HOST_THIRD_PARTY_ID) private readonly hostThirdPartyId: string,
        private readonly navController: NavController,
        private readonly route: ActivatedRoute) {
        super();
    }

    ngOnInit(): void {
        this.supportContactService.findSupportContacts(this.hostThirdPartyId)
            .subscribe(supportContacts => this.supportContacts = supportContacts);
    }

    ionViewWillEnter(): void {
        this.ghostMode = true;
    }

    ionViewDidEnter(): void {
        this.faqHttpService.findNode(this.route.snapshot.paramMap.get('faqNodeId'))
            .pipe(finalize(() => this.ghostMode = false))
            .subscribe(faqNodeDetailDto => {
                this.faqNodeDetailDto = faqNodeDetailDto;
            });
    }

    goToFaqNode(faqNode: FaqNodeDto): void {
        this.navController.navigateForward(`help/faq/${faqNode.id}`);
    }

    generateGhost(): void {
        this.faqNodeDetailDto = {
            id: '',
            '@type': FaqNodeType.PAGE,
            title: '',
            content: ''
        } as FaqPageDetailDto;
    }
}
